import {PipeTransform, Pipe} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';

@Pipe({
  name: 'trustAsCss'
})
export class TrustAsCssPipe  implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
    this.sanitizer = sanitizer;
  }

  transform(value) {
    if (!value) {
      return value;
    }
    const style: SafeStyle = this.sanitizer.bypassSecurityTrustStyle(value);
    return style;
  }

}

